import _ from 'lodash';

let initAbsences = {
	expires: 0,
	submitting: false,
	adding: false,
	added: false,
	failed_to_add: false,
	data: []
}

const absences = (state = initAbsences, action) => {
	switch (action.type) {
		case 'USER_FAILURE':
		case 'MEMBER_FAILURE':
		case 'LOGOUT_SUCCESS':
		case 'LOGIN_SUCCESS':
			return initAbsences;
		case 'ABSENCES_REQUEST':
			return {...state, submitting: true}
		case 'ADD_ABSENCE_REQUEST':
			return {...state, adding: true, added: false, failed_to_add: false}
		case 'ABSENCES_SUCCESS':
			const expires = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr
			return {...state, expires: expires, submitting: false, data: _.orderBy(action.response, ['start_date', 'finish_date', 'course_name']) }
		case 'ADD_ABSENCE_SUCCESS':
			const exp = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr
			return {...state, 
				expires: exp, 
				adding: false, 
				added: true,
				failed_to_add: false,
				data: _.orderBy(action.response, ['start_date', 'finish_date', 'course_name']) 
			}
		case 'ABSENCES_FAILURE':
			return {...state, submitting: false}
		case 'ADD_ABSENCE_FAILURE':
			return {...state, adding: false, added: false, failed_to_add: true}
		default:
			return state;
	}
}
export default absences

